import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Navigation from '.';

type Props = {
  routesWithNavigation: string[];
};
const NavigationRoutes: FC<Props> = ({ routesWithNavigation }) => {
  return (
    <Routes>
      <Route path="/*" element={null}></Route>
      {routesWithNavigation.map((route, index) => (
        <Route path={route} key={index} element={<Navigation />} />
      ))}
    </Routes>
  );
};

export default NavigationRoutes;
